import "@honeycomb/ui/ui.css";
import "./styles/index.scss";
import "@honeycomb/sentinel/sentinel.css";

import { render } from "react-dom";

import { App } from "./app";

const appElement = document.getElementById("app");

render(<App />, appElement);
